/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdraftdiscardbody3Inputs */

const en_eventdraftdiscardbody3 = /** @type {(inputs: Eventdraftdiscardbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything entered in this draft, pictures included, will be deleted.`)
};

const de_eventdraftdiscardbody3 = /** @type {(inputs: Eventdraftdiscardbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Eingaben und Bilder dieses Entwurfs werden gelöscht.`)
};

/**
* | output |
* | --- |
* | "Everything entered in this draft, pictures included, will be deleted." |
*
* @param {Eventdraftdiscardbody3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdraftdiscardbody3 = /** @type {((inputs?: Eventdraftdiscardbody3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdraftdiscardbody3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdraftdiscardbody3(inputs)
	return de_eventdraftdiscardbody3(inputs)
});
export { eventdraftdiscardbody3 as "eventDraftDiscardBody" }